"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9217],{

/***/ 66176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _insightfulscience_atomic_react_Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25522);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67478);
/* harmony import */ var _Image_Caption__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7267);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10334);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67924);








const FImage = (param)=>{
    let { caption , imageCaptionClassName , isImageFrame , imageClassName , shadow , src , alt , isBaseUrl  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image_Caption__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        caption: caption,
        className: imageCaptionClassName,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_6__/* .classes */ .S)(isImageFrame && "feature__image--frame", imageClassName),
            shadow: shadow,
            src: src,
            alt: alt,
            isBaseUrl: isBaseUrl
        })
    });
};
FImage.propTypes = {
    shadow: prop_types__WEBPACK_IMPORTED_MODULE_7__.bool,
    src: prop_types__WEBPACK_IMPORTED_MODULE_7__.string.isRequired,
    alt: prop_types__WEBPACK_IMPORTED_MODULE_7__.string,
    caption: prop_types__WEBPACK_IMPORTED_MODULE_7__.string,
    isImageFrame: prop_types__WEBPACK_IMPORTED_MODULE_7__.bool,
    imageCaptionClassName: prop_types__WEBPACK_IMPORTED_MODULE_7__.string,
    imageClassName: prop_types__WEBPACK_IMPORTED_MODULE_7__.string,
    isBaseUrl: prop_types__WEBPACK_IMPORTED_MODULE_7__.bool
};
const FeatureImage = (param)=>/*#__PURE__*/ {
    let { shadow =false , src , alt ="" , caption ="" , sm =12 , md =6 , className ="" , isImageFrame =false , imageCaptionClassName ="" , imageClassName ="" , isBaseUrl , href ="" , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Col */ .JX, {
        sm: sm,
        md: md,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_6__/* .classes */ .S)("feature__image", className),
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "feature__image--indent",
            children: href ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                href: href,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FImage, {
                    caption: caption,
                    imageCaptionClassName: imageCaptionClassName,
                    isImageFrame: isImageFrame,
                    imageClassName: imageClassName,
                    shadow: shadow,
                    src: src,
                    alt: alt,
                    isBaseUrl: isBaseUrl
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FImage, {
                caption: caption,
                imageCaptionClassName: imageCaptionClassName,
                isImageFrame: isImageFrame,
                imageClassName: imageClassName,
                shadow: shadow,
                src: src,
                alt: alt,
                isBaseUrl: isBaseUrl
            })
        })
    });
};
FeatureImage.propTypes = {
    shadow: prop_types__WEBPACK_IMPORTED_MODULE_7__.bool,
    src: prop_types__WEBPACK_IMPORTED_MODULE_7__.string.isRequired,
    alt: prop_types__WEBPACK_IMPORTED_MODULE_7__.string,
    caption: prop_types__WEBPACK_IMPORTED_MODULE_7__.string,
    sm: _Grid__WEBPACK_IMPORTED_MODULE_3__/* .Col.propTypes.sm */ .JX.propTypes.sm,
    md: _Grid__WEBPACK_IMPORTED_MODULE_3__/* .Col.propTypes.md */ .JX.propTypes.md,
    isImageFrame: prop_types__WEBPACK_IMPORTED_MODULE_7__.bool,
    imageCaptionClassName: prop_types__WEBPACK_IMPORTED_MODULE_7__.string,
    imageClassName: prop_types__WEBPACK_IMPORTED_MODULE_7__.string,
    isBaseUrl: prop_types__WEBPACK_IMPORTED_MODULE_7__.bool,
    className: prop_types__WEBPACK_IMPORTED_MODULE_7__.string,
    href: prop_types__WEBPACK_IMPORTED_MODULE_7__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (FeatureImage);


/***/ }),

/***/ 1041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2349);
/* harmony import */ var _Block__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6949);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67478);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42866);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67924);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7820);
/* harmony import */ var _props_utility__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18981);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(23720);











const Label = (param)=>/*#__PURE__*/ {
    let { children , type ="default" , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_2__/* .spacingProps */ .tF
    } , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_6__/* .classes */ .S)("feature__meta-label-".concat(type), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_2__/* .spacingClassName */ .RB)(spacing)),
        ...props,
        children: children
    });
};
Label.propTypes = {
    type: (0,prop_types__WEBPACK_IMPORTED_MODULE_9__.oneOf)([
        "default",
        "without-line"
    ]),
    spacing: _props_spacing__WEBPACK_IMPORTED_MODULE_2__/* .spacingPropTypes */ .Xj,
    children: prop_types__WEBPACK_IMPORTED_MODULE_9__.node.isRequired
};
const Title = (param)=>/*#__PURE__*/ {
    let { utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_7__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_8__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_2__/* .spacingProps */ .tF
    } , children , className ="" , underline , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        Tag: "h3",
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_6__/* .classes */ .S)("feature__meta-title", underline && "feature__meta-title--border-".concat(underline), ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_7__/* .utilityClassName */ .b2)(utility), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_8__/* .sxClassName */ .ZA)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_10__/* .deepMergeProps */ .p)({
            fontSize: "l"
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(sx)), true), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_2__/* .spacingClassName */ .RB)(spacing), className),
        ...props,
        children: children
    });
};
Title.propTypes = {
    underline: (0,prop_types__WEBPACK_IMPORTED_MODULE_9__.oneOf)([
        "top-left",
        "top-right",
        "top-right--md"
    ]),
    ..._Heading__WEBPACK_IMPORTED_MODULE_5__/* ["default"].propTypes */ .Z.propTypes
};
const Description = (param)=>/*#__PURE__*/ {
    let { children , className , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_6__/* .classes */ .S)("feature__meta-description", className),
        ...props,
        children: children
    });
};
Description.propTypes = {
    ..._Block__WEBPACK_IMPORTED_MODULE_3__/* ["default"].propTypes */ .Z.propTypes
};
const Action = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: children
    });
};
Action.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_9__.node.isRequired
};
const FeatureMeta = (param)=>{
    let { numberItem , children , sm =12 , md =6 , className ="" , indent =true , numberProps ={} , ...props } = param;
    const { sx ={} , utility ={} , spacing ={}  } = numberProps;
    const blockClassName = (numberProps === null || numberProps === void 0 ? void 0 : numberProps.className) || null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .JX, {
        sm: sm,
        md: md,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_6__/* .classes */ .S)("feature__meta", className),
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_6__/* .classes */ .S)(indent && "feature__meta--indent"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Row */ .X2, {
                children: [
                    numberItem ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .JX, {
                        shrink: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_6__/* .classes */ .S)("feature__meta-number", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_7__/* .utilityClassName */ .b2)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(utility)), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_8__/* .sxClassName */ .ZA)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(sx)), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_2__/* .spacingClassName */ .RB)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(spacing)), blockClassName),
                            children: numberItem
                        })
                    }) : null,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .JX, {
                        auto: true,
                        children: children
                    })
                ]
            })
        })
    });
};
FeatureMeta.propTypes = {
    numberItem: prop_types__WEBPACK_IMPORTED_MODULE_9__.string,
    className: prop_types__WEBPACK_IMPORTED_MODULE_9__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_9__.node.isRequired,
    sm: _Grid__WEBPACK_IMPORTED_MODULE_4__/* .Col.propTypes.sm */ .JX.propTypes.sm,
    md: _Grid__WEBPACK_IMPORTED_MODULE_4__/* .Col.propTypes.md */ .JX.propTypes.md,
    indent: prop_types__WEBPACK_IMPORTED_MODULE_9__.bool,
    numberProps: (0,prop_types__WEBPACK_IMPORTED_MODULE_9__.shape)({
        sx: _props_sx__WEBPACK_IMPORTED_MODULE_8__/* .sxPropTypes */ .I1,
        spacing: _props_spacing__WEBPACK_IMPORTED_MODULE_2__/* .spacingPropTypes */ .Xj,
        utility: _props_utility__WEBPACK_IMPORTED_MODULE_7__/* .utilityPropTypes */ .pQ,
        className: prop_types__WEBPACK_IMPORTED_MODULE_9__.string
    })
};
FeatureMeta.Label = Label;
FeatureMeta.Title = Title;
FeatureMeta.Description = Description;
FeatureMeta.Action = Action;
/* harmony default export */ __webpack_exports__["Z"] = (FeatureMeta);


/***/ }),

/***/ 55185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Feature_Feature; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Feature/Feature.js





const Feature = (param)=>{
    let { top =false , middle =true , children , className ="" , ...props } = param;
    const alignProps = top === true ? {
        start: true,
        middle: false
    } : {
        start: false,
        middle
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
        px: true,
        className: (0,classes/* classes */.S)("feature", className),
        ...alignProps,
        ...props,
        children: children
    });
};
Feature.propTypes = {
    top: prop_types.bool,
    middle: prop_types.bool,
    children: prop_types.node.isRequired,
    className: prop_types.string
};
/* harmony default export */ var Feature_Feature = (Feature);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Feature/index.js



/***/ }),

/***/ 14593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36432);




const HeroAction = (param)=>/*#__PURE__*/ {
    let { center =true , children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .HeroRow */ .P, {
        center: center,
        className: "section-hero__action",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .HeroCol */ .Z, {
            children: children
        })
    });
};
HeroAction.propTypes = {
    center: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroAction);


/***/ }),

/***/ 85765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18774);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);





const HeroButtonLink = (param)=>{
    let { className ="" , size ="s" , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Link */ .Z.Link, {
        size: size,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("section-hero__button", className),
        ...props
    });
};
HeroButtonLink.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    size: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    ..._Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroButtonLink);


/***/ }),

/***/ 37045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _SimpleSection__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72989);




const LandingSimpleSectionStripped = (param)=>{
    let { isDark =false , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SimpleSection__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        utility: {
            bgColor: isDark ? "black--02" : null
        },
        isBorderNone: true,
        ...props
    });
};
LandingSimpleSectionStripped.propTypes = {
    isDark: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    ..._SimpleSection__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (LandingSimpleSectionStripped);


/***/ }),

/***/ 51144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ AlertPreviewMode_AlertPreviewMode; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/ui/AlertPreviewMode/AlertPreviewMode.js




const AlertPreviewMode = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
        utility: {
            bgColor: "black"
        },
        spacing: {
            p: 4
        },
        style: {
            position: "fixed",
            top: 0,
            right: 0,
            zIndex: 9999
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
            href: "/api/preview-disable",
            sx: {
                fontColor: "white",
                hover: {
                    fontColor: "black--15"
                }
            },
            children: "Disable Preview Mode"
        })
    });
/* harmony default export */ var AlertPreviewMode_AlertPreviewMode = (AlertPreviewMode);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/ui/AlertPreviewMode/index.js



/***/ }),

/***/ 17335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ utils_checkPreviewMode; }
});

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/utils/cookie/client.js
const getCookie = (name)=>{
    const cookie = document.cookie.split("; ").map((item)=>item.split("=")).filter((item)=>item[0] === name);
    if (cookie.length) {
        return cookie[0][1];
    }
    return null;
};

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/utils/checkPreviewMode.js

const checkPreviewMode = function(serverReq) {
    let cookieName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "contentfulPreview";
    const isBrowser = !serverReq;
    const cookieValue = isBrowser ? getCookie(cookieName) : serverReq.cookies[cookieName];
    if (cookieValue) {
        return true;
    }
    return false;
};
/* harmony default export */ var utils_checkPreviewMode = (checkPreviewMode);


/***/ }),

/***/ 19941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ file; },
/* harmony export */   "x": function() { return /* binding */ pageProps; }
/* harmony export */ });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);

const file = (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
    fields: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
        title: prop_types__WEBPACK_IMPORTED_MODULE_0__.string,
        description: prop_types__WEBPACK_IMPORTED_MODULE_0__.string,
        file: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
            url: prop_types__WEBPACK_IMPORTED_MODULE_0__.string,
            fileName: prop_types__WEBPACK_IMPORTED_MODULE_0__.string,
            contentType: prop_types__WEBPACK_IMPORTED_MODULE_0__.string
        })
    })
});
const pageProps = (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
    resources: prop_types__WEBPACK_IMPORTED_MODULE_0__.any,
    siteDomain: prop_types__WEBPACK_IMPORTED_MODULE_0__.string.isRequired,
    prefix: prop_types__WEBPACK_IMPORTED_MODULE_0__.string,
    brandCode: prop_types__WEBPACK_IMPORTED_MODULE_0__.string,
    components: prop_types__WEBPACK_IMPORTED_MODULE_0__.any
});


/***/ }),

/***/ 94061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ renderBlockByType; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PageNavbar/index.js + 1 modules
var PageNavbar = __webpack_require__(11794);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PageNavbar/Item.js
var Item = __webpack_require__(361);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PageNavbar/Link.js
var Link = __webpack_require__(24661);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/components/LinksBlock/Link.js





const LinkBlock = (param)=>/*#__PURE__*/ {
    let { linkText , linkUrl  } = param;
    return (0,jsx_runtime.jsx)(Item/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
            href: linkUrl,
            children: linkText
        })
    });
};
LinkBlock.propTypes = {
    linkText: prop_types.string.isRequired,
    linkUrl: prop_types.string.isRequired
};

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/components/LinksBlock/LinksBlock.js





const LinksBlock = (param)=>{
    let { linkReference , stickyToc =false  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageNavbar/* default */.Z, {
        alignHorizontal: "around",
        fullWidthBorder: true,
        utility: {
            bgColor: "white"
        },
        sticky: stickyToc,
        children: linkReference.map((param)=>/*#__PURE__*/ {
            let { fields  } = param;
            return (0,jsx_runtime.jsx)(LinkBlock, {
                ...fields
            }, fields.linkUrl);
        })
    });
};
LinksBlock.propTypes = {
    stickyToc: prop_types.bool,
    linkReference: (0,prop_types.arrayOf)((0,prop_types.shape)({
        fields: (0,prop_types.shape)({
            linkText: prop_types.string.isRequired,
            linkUrl: prop_types.string.isRequired
        })
    }))
};
/* harmony default export */ var LinksBlock_LinksBlock = (LinksBlock);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/components/LinksBlock/index.js


// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/index.js + 1 modules
var Hero = __webpack_require__(69591);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Title.js
var Title = __webpack_require__(91319);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Description.js
var Description = __webpack_require__(50410);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Action.js
var Action = __webpack_require__(14593);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Grid.js
var Grid = __webpack_require__(36432);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/ButtonLink.js
var ButtonLink = __webpack_require__(85765);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var atomic_react_Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Image/index.js + 1 modules
var Image = __webpack_require__(10334);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/utils/propTypes.js
var propTypes = __webpack_require__(19941);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/ui/WistiaVideoEmbed.js + 1 modules
var WistiaVideoEmbed = __webpack_require__(10917);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/components/HeroBlock/HeroBlock.js














const HeroInfo = (param)=>{
    let { title , lead , primaryCtaLink , primaryCtaText , secondaryCtaLink , secondaryCtaText , isLeft  } = param;
    const isHasActions = primaryCtaText && primaryCtaLink || secondaryCtaText && secondaryCtaLink;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                children: title
            }),
            lead && /*#__PURE__*/ (0,jsx_runtime.jsx)(Description/* default */.Z, {
                children: lead
            }),
            isHasActions && /*#__PURE__*/ (0,jsx_runtime.jsx)(Action/* default */.Z, {
                center: !isLeft,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* HeroRow */.P, {
                    children: [
                        primaryCtaText && primaryCtaLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* HeroCol */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                                href: primaryCtaLink,
                                styleType: "secondary",
                                children: primaryCtaText
                            })
                        }),
                        secondaryCtaText && secondaryCtaLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* HeroCol */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                                href: secondaryCtaLink,
                                styleType: "secondary",
                                isOutline2: true,
                                children: secondaryCtaText
                            })
                        })
                    ]
                })
            })
        ]
    });
};
HeroInfo.propTypes = {
    title: prop_types.string,
    lead: prop_types.string,
    primaryCtaLink: prop_types.string,
    primaryCtaText: prop_types.string,
    secondaryCtaLink: prop_types.string,
    secondaryCtaText: prop_types.string,
    isLeft: prop_types.bool
};
const HeroBlock = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    const { backgroundColor , backgroundImage , foregroundImage , foregroundVideo , alignment  } = props;
    const isVideoExist = !!(foregroundVideo === null || foregroundVideo === void 0 ? void 0 : (ref = foregroundVideo.fields) === null || ref === void 0 ? void 0 : ref.videoUrl);
    const isImgExist = !!(foregroundImage === null || foregroundImage === void 0 ? void 0 : (ref1 = foregroundImage.fields) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.file) === null || ref2 === void 0 ? void 0 : ref2.url);
    const isNeedShowRightCol = isVideoExist || isImgExist;
    const isLeft = alignment === "Left";
    const rightColumnConf = isLeft ? {
        md: 6,
        lg: 7
    } : {
        md: 12,
        lg: 12
    };
    const leftColumnConf = isLeft ? {
        md: 6,
        lg: 5
    } : {
        md: 12,
        lg: 12
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* default */.Z, {
        color: backgroundColor,
        spacing: {
            py: 18
        },
        backgroundImage: backgroundImage === null || backgroundImage === void 0 ? void 0 : (ref3 = backgroundImage.fields) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.file) === null || ref4 === void 0 ? void 0 : ref4.url,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(atomic_react_Grid/* Row */.X2, {
            mx: true,
            utility: {
                align: {
                    items: "center"
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                    ...isNeedShowRightCol && leftColumnConf,
                    smOrder: 1,
                    mdOrder: 0,
                    className: (0,classes/* classes */.S)(isLeft && "text-left"),
                    spacing: {
                        mb: isNeedShowRightCol ? 10 : 0,
                        sm: {
                            mb: 0
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroInfo, {
                        ...props,
                        isLeft: isLeft
                    })
                }),
                isNeedShowRightCol && /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                    ...rightColumnConf,
                    smOrder: 0,
                    mdOrder: 1,
                    spacing: {
                        sm: {
                            mb: 10
                        }
                    },
                    children: isVideoExist ? /*#__PURE__*/ (0,jsx_runtime.jsx)(WistiaVideoEmbed/* default */.Z, {
                        url: foregroundVideo.fields.videoUrl
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: foregroundImage === null || foregroundImage === void 0 ? void 0 : (ref5 = foregroundImage.fields) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.file) === null || ref6 === void 0 ? void 0 : ref6.url,
                        isBaseUrl: false
                    })
                })
            ]
        })
    });
};
HeroBlock.propTypes = {
    alignment: (0,prop_types.oneOf)([
        "Left",
        "Center"
    ]),
    backgroundColor: prop_types.string,
    backgroundImage: propTypes/* file */.t,
    foregroundImage: propTypes/* file */.t,
    foregroundVideo: (0,prop_types.shape)({
        fields: (0,prop_types.shape)({
            videoUrl: prop_types.string
        })
    }),
    title: prop_types.string,
    lead: prop_types.string,
    primaryCtaLink: prop_types.string,
    primaryCtaText: prop_types.string,
    secondaryCtaLink: prop_types.string,
    secondaryCtaText: prop_types.string
};
/* harmony default export */ var HeroBlock_HeroBlock = (HeroBlock);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/components/HeroBlock/index.js


// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Feature/index.js + 1 modules
var Feature = __webpack_require__(55185);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Feature/Meta.js
var Meta = __webpack_require__(1041);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Feature/Image.js
var Feature_Image = __webpack_require__(66176);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Button/index.js + 1 modules
var Button = __webpack_require__(18774);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var atomic_react_Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-react-renderer/dist/rich-text-react-renderer.es5.js
var rich_text_react_renderer_es5 = __webpack_require__(74129);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Icon/index.js + 1 modules
var Icon = __webpack_require__(61672);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/LandingElement/SimpleSectionStripped.js
var SimpleSectionStripped = __webpack_require__(37045);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/LandingElement/SimpleSection.js
var SimpleSection = __webpack_require__(72989);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/components/Template/Template.js





const Template = (param)=>{
    let { title , subtitle , backgroundColor , anchor , children , textAlign ="center" , containerProps  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSectionStripped/* default */.Z, {
        bgColor: backgroundColor,
        containerProps: containerProps,
        children: [
            anchor && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                name: anchor,
                href: "/",
                children: " "
            }),
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.Title */.Z.Title, {
                sx: {
                    textAlign
                },
                spacing: {
                    mb: !subtitle ? 16 : 0
                },
                children: title
            }),
            subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.DescriptionV2 */.Z.DescriptionV2, {
                sx: {
                    textAlign
                },
                children: subtitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.Body */.Z.Body, {
                children: children
            })
        ]
    });
};
Template.propTypes = {
    title: prop_types.string,
    subtitle: prop_types.string,
    backgroundColor: prop_types.string,
    anchor: prop_types.string,
    children: prop_types.node.isRequired,
    textAlign: (0,prop_types.oneOf)([
        "left",
        "center"
    ]),
    containerProps: (0,prop_types.shape)({
        sm: (0,prop_types.oneOf)([
            "",
            "auto",
            "shrink",
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12
        ]),
        md: (0,prop_types.oneOf)([
            "",
            "auto",
            "shrink",
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12
        ]),
        lg: (0,prop_types.oneOf)([
            "",
            "auto",
            "shrink",
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12
        ]),
        center: prop_types.bool
    })
};
/* harmony default export */ var Template_Template = (Template);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/components/Template/index.js


// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/richTextTypes/default/index.js + 6 modules
var richTextTypes_default = __webpack_require__(3877);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/components/VisualCopyBlock/VisualCopyBlock.js















const VisualCopyBlock = (param)=>{
    let { blockTitle , blockSubtitle , alignment ="Left" , heading , leadID , image , secondaryCtaText , secondaryCtaLink , ctaText , ctaLink , video , backgroundColor , internalSlug , withTemplate =true , blockTitleAlignedLeft =false  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    const isImgExist = !!(image === null || image === void 0 ? void 0 : (ref = image.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.file) === null || ref1 === void 0 ? void 0 : ref1.url);
    const isIVideoExist = !!(video === null || video === void 0 ? void 0 : (ref2 = video.fields) === null || ref2 === void 0 ? void 0 : ref2.videoUrl);
    const isHasActions = secondaryCtaText && secondaryCtaLink;
    const Wrapper = withTemplate ? Template_Template : react.Fragment;
    const wrapperProps = withTemplate ? {
        title: blockTitle,
        subtitle: blockSubtitle,
        backgroundColor,
        anchor: internalSlug,
        textAlign: blockTitleAlignedLeft ? "left" : "center"
    } : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        ...wrapperProps,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Feature/* default */.Z, {
                px: false,
                children: [
                    alignment === "Right" && isIVideoExist && /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                        md: 8,
                        spacing: {
                            md: {
                                p: 10
                            },
                            lg: {
                                p: 10
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WistiaVideoEmbed/* default */.Z, {
                            url: video === null || video === void 0 ? void 0 : (ref3 = video.fields) === null || ref3 === void 0 ? void 0 : ref3.videoUrl
                        })
                    }) || alignment === "Right" && isImgExist && !isIVideoExist && /*#__PURE__*/ (0,jsx_runtime.jsx)(Feature_Image/* default */.Z, {
                        src: image === null || image === void 0 ? void 0 : (ref4 = image.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.file) === null || ref5 === void 0 ? void 0 : ref5.url,
                        md: 8,
                        isImageFrame: true,
                        isBaseUrl: false
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Meta/* default */.Z, {
                        md: 4,
                        indent: false,
                        children: [
                            heading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Title */.Z.Title, {
                                children: heading
                            }),
                            leadID && /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Description */.Z.Description, {
                                children: (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(leadID, richTextTypes_default/* default */.Z)
                            }),
                            isHasActions && /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Action */.Z.Action, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Row */.X2, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(atomic_react_Link/* default */.Z, {
                                            href: secondaryCtaLink,
                                            sx: {
                                                fontSize: "m"
                                            },
                                            children: [
                                                secondaryCtaText,
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                    name: "angle-right"
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    alignment === "Left" && isIVideoExist && /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                        md: 8,
                        spacing: {
                            md: {
                                p: 10
                            },
                            lg: {
                                p: 10
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WistiaVideoEmbed/* default */.Z, {
                            url: video === null || video === void 0 ? void 0 : (ref6 = video.fields) === null || ref6 === void 0 ? void 0 : ref6.videoUrl
                        })
                    }) || alignment === "Left" && isImgExist && !isIVideoExist && /*#__PURE__*/ (0,jsx_runtime.jsx)(Feature_Image/* default */.Z, {
                        src: image === null || image === void 0 ? void 0 : (ref7 = image.fields) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.file) === null || ref8 === void 0 ? void 0 : ref8.url,
                        md: 8,
                        isImageFrame: true,
                        isBaseUrl: false
                    })
                ]
            }),
            ctaLink && ctaText && /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Row */.X2, {
                spacing: {
                    mt: 15
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                    center: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default.Link */.Z.Link, {
                        href: ctaLink,
                        styleType: "secondary",
                        size: "s",
                        children: ctaText
                    })
                })
            })
        ]
    });
};
VisualCopyBlock.propTypes = {
    internalSlug: prop_types.string.isRequired,
    blockTitle: prop_types.string,
    blockSubtitle: prop_types.string,
    alignment: (0,prop_types.oneOf)([
        "Left",
        "Right"
    ]),
    heading: prop_types.string,
    leadID: prop_types.object,
    image: propTypes/* file */.t,
    secondaryCtaText: prop_types.string,
    secondaryCtaLink: prop_types.string,
    ctaText: prop_types.string,
    ctaLink: prop_types.string,
    backgroundColor: prop_types.string,
    withTemplate: prop_types.bool,
    blockTitleAlignedLeft: prop_types.bool,
    video: (0,prop_types.shape)({
        fields: (0,prop_types.shape)({
            videoUrl: prop_types.string
        })
    })
};
/* harmony default export */ var VisualCopyBlock_VisualCopyBlock = (VisualCopyBlock);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/components/VisualCopyBlock/index.js


;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/utils/colToRows.js
const colToRows = (colsCount, column)=>{
    const { length  } = column;
    // eslint-disable-next-line no-param-reassign
    colsCount = Math.min(colsCount, length) || 1;
    const fullColsCount = length % colsCount || colsCount;
    const fullRowsCount = Math.floor(length / colsCount);
    const rowsCount = Math.ceil(length / colsCount);
    const shortColumnOffset = rowsCount * fullColsCount;
    return Array.from({
        length: rowsCount
    }, (_, row)=>Array.from({
            length: row < fullRowsCount ? colsCount : fullColsCount
        }, (__, col)=>col < fullColsCount ? column[col * rowsCount + row] : column[shortColumnOffset + (col - fullColsCount) * fullRowsCount + row]));
};
/* harmony default export */ var utils_colToRows = (colToRows);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/components/CopyBlock/CopyBlock.js









const groupByHeading = (content, numberOfBlocks)=>{
    const headTypes = [
        "heading-1",
        "heading-2",
        "heading-3",
        "heading-4",
        "heading-5",
        "heading-6"
    ];
    let column = [];
    let numInColumn = 1;
    return content.reduce((prev, item, key, arr)=>{
        if (column.length && headTypes.includes(item.nodeType) && numInColumn === 1) {
            prev.push(column);
            column = [];
        }
        column.push(item);
        if (arr.length - 1 === key) prev.push(column);
        if (headTypes.includes(item.nodeType)) {
            numInColumn = numInColumn === numberOfBlocks ? 1 : numInColumn + 1;
        }
        return prev;
    }, []);
};
const CopyBlock = (param)=>{
    let { id , blockTitle , blockSubtitle , text: { content =[]  } , numberOfColumns , numberOfQuestions =1 , ctaLink , ctaText , backgroundColor , alignment ="Left" , internalSlug , faqCopy =false  } = param;
    const borderStyles = !faqCopy ? {
        border: {
            left: {
                width: 1,
                color: "black--20"
            }
        }
    } : {};
    const containerProps = numberOfColumns === 1 ? {
        lg: 9,
        center: true
    } : {};
    const numberOfBlocks = faqCopy ? numberOfQuestions : 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Template_Template, {
        title: blockTitle,
        subtitle: blockSubtitle,
        backgroundColor: backgroundColor,
        anchor: internalSlug,
        containerProps: containerProps,
        children: [
            utils_colToRows(numberOfColumns, groupByHeading(content, numberOfBlocks)).map((column, rowKey)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Row */.X2, {
                    mx: numberOfColumns !== 1,
                    my: true,
                    children: column.map((items, colKey)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                            md: 12 / numberOfColumns,
                            spacing: {
                                md: {
                                    px: 3
                                },
                                my: 8
                            },
                            utility: {
                                lg: {
                                    ...borderStyles
                                }
                            },
                            sx: {
                                textAlign: alignment === "Center" ? "center" : "left"
                            },
                            children: items.map((item, key)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                    children: (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(item, richTextTypes_default/* default */.Z)
                                }, "".concat(id, "-row-").concat(rowKey, "-col-").concat(colKey, "-").concat(key)))
                        }, "".concat(id, "-row-").concat(rowKey, "-col-").concat(colKey)))
                }, "".concat(id, "-row-").concat(rowKey))),
            ctaLink && ctaText && /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Row */.X2, {
                spacing: {
                    mt: 10
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                    center: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default.Link */.Z.Link, {
                        href: ctaLink,
                        styleType: "secondary",
                        size: "s",
                        isPreLine: true,
                        children: ctaText
                    })
                })
            })
        ]
    });
};
CopyBlock.propTypes = {
    internalSlug: prop_types.string.isRequired,
    id: prop_types.string,
    alignment: (0,prop_types.oneOf)([
        "Left",
        "Center"
    ]),
    text: prop_types.object,
    blockTitle: prop_types.string,
    blockSubtitle: prop_types.string,
    numberOfColumns: prop_types.number,
    numberOfQuestions: prop_types.number,
    backgroundColor: prop_types.string,
    ctaText: prop_types.string,
    ctaLink: prop_types.string,
    faqCopy: prop_types.bool
};
/* harmony default export */ var CopyBlock_CopyBlock = (CopyBlock);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/components/CopyBlock/index.js


;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Testimonial/hooks/useTestimonial.js

function useTestimonial(list) {
    const [activeIndex, setActiveIndex] = (0,react.useState)(0);
    const active = (0,react.useMemo)(()=>list[activeIndex], [
        activeIndex,
        list
    ]);
    return [
        active,
        activeIndex,
        setActiveIndex
    ];
}
/* harmony default export */ var hooks_useTestimonial = (useTestimonial);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Testimonial/Tabs.js







const TestimonialTab = (param)=>{
    let { logoImg , active =false  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
        md: 4,
        lg: 2,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            className: (0,classes/* classes */.S)("testimonials-customers__tab ", active && "active"),
            styleType: "link",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: logoImg
            })
        })
    });
};
TestimonialTab.propTypes = {
    logoImg: prop_types.string.isRequired,
    active: prop_types.bool
};
const TestimonialTabs = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Row */.X2, {
        mx: true,
        my: true,
        children: children
    });
};
TestimonialTabs.propTypes = {
    children: prop_types.node.isRequired
};
/* harmony default export */ var Tabs = (TestimonialTabs);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Testimonial/Tab.js







const TestimonialTabsItem = (param)=>{
    let { logoImg , isBaseUrl , active =false , grayscale =false , invert , onClick =()=>{}  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
        md: 4,
        lg: 2,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            className: (0,classes/* classes */.S)("testimonials-customers__tab ", active && "active"),
            styleType: "link",
            onClick: onClick,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: logoImg,
                isBaseUrl: isBaseUrl,
                grayscale: grayscale,
                invert: invert
            })
        })
    });
};
TestimonialTabsItem.propTypes = {
    logoImg: prop_types.string.isRequired,
    onClick: prop_types.func,
    grayscale: prop_types.bool,
    invert: (0,prop_types.oneOf)([
        "white",
        "black"
    ]),
    active: prop_types.bool,
    isBaseUrl: prop_types.bool
};
/* harmony default export */ var Tab = (TestimonialTabsItem);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Testimonial/Grid.js



const TestimonialColInfo = (param)=>/*#__PURE__*/ {
    let { ...props } = param;
    return (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
        lg: 6,
        spacing: {
            sm: {
                pl: 8,
                pr: 12,
                py: 6
            },
            md: {
                pl: 12,
                pr: 12,
                py: 10
            }
        },
        ...props
    });
};
const TestimonialColVideo = (param)=>/*#__PURE__*/ {
    let { ...props } = param;
    return _jsx(Col, {
        lg: 6,
        className: "hide-for-medium-only",
        ...props
    });
};
const TestimonialColImage = (param)=>/*#__PURE__*/ {
    let { ...props } = param;
    return _jsx(Col, {
        lg: 6,
        ...props
    });
};
const TestimonialColLogo = (param)=>/*#__PURE__*/ {
    let { ...props } = param;
    return (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
        md: 6,
        className: "align-self-middle text-center",
        spacing: {
            sm: {
                pl: 8,
                pr: 12,
                py: 6
            },
            md: {
                pl: 12,
                pr: 12,
                py: 10
            }
        },
        ...props
    });
};

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureProps.js
var pureProps = __webpack_require__(7820);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Testimonial/BlockQuote.js







const TestimonialBlockQuote = (param)=>/*#__PURE__*/ {
    let { author , company , children , sx ={
        ...props_sx/* sxProps */.ET
    }  } = param;
    return (0,jsx_runtime.jsxs)(Block/* default */.Z, {
        className: "testimonial__blockquote",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
                spacing: {
                    mb: 4
                },
                sx: (0,pureProps/* deepMergeProps */.p)({
                    fontSize: "xl"
                }, (0,pureProps/* default */.Z)(sx)),
                children: children
            }),
            author && /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
                className: (0,classes/* classes */.S)("testimonials-author__name"),
                children: author
            }),
            company && /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
                className: (0,classes/* classes */.S)("testimonials-author__brand"),
                children: company
            })
        ]
    });
};
TestimonialBlockQuote.propTypes = {
    author: prop_types.string.isRequired,
    company: prop_types.string.isRequired,
    children: prop_types.node.isRequired,
    sx: props_sx/* sxPropTypes */.I1
};
/* harmony default export */ var BlockQuote = (TestimonialBlockQuote);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Testimonial/Testimonial.js



const Testimonial = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Row */.X2, {
        ...props
    });
};
Testimonial.propTypes = {
    ...atomic_react_Grid/* Row.propTypes */.X2.propTypes
};
/* harmony default export */ var Testimonial_Testimonial = (Testimonial);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Testimonial/index.js


;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/components/TestimonialsBlock/Testimonial.js








const TestimonialItem = (param)=>{
    let { logo , position , quoteAuthor , quoteText  } = param;
    var ref, ref1, ref2, ref3;
    const isImgExist = logo === null || logo === void 0 ? void 0 : (ref = logo.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.file) === null || ref1 === void 0 ? void 0 : ref1.url;
    const infoColumnWidth = isImgExist ? {
        md: 8,
        lg: 10
    } : {
        md: 12,
        lg: 12
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Testimonial_Testimonial, {
        mx: true,
        spacing: {
            mb: 8,
            sm: {
                px: 2
            }
        },
        children: [
            isImgExist && /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialColLogo, {
                md: 4,
                lg: 2,
                spacing: {
                    sm: {
                        mb: 8
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: logo === null || logo === void 0 ? void 0 : (ref2 = logo.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.file) === null || ref3 === void 0 ? void 0 : ref3.url,
                    isBaseUrl: false
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialColInfo, {
                md: infoColumnWidth.md,
                lg: infoColumnWidth.lg,
                spacing: {},
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockQuote, {
                    author: quoteAuthor,
                    company: position,
                    children: quoteText
                })
            })
        ]
    });
};
TestimonialItem.propTypes = {
    logo: propTypes/* file */.t,
    position: prop_types.string,
    quoteAuthor: prop_types.string,
    quoteText: prop_types.string
};
/* harmony default export */ var TestimonialsBlock_Testimonial = (TestimonialItem);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/components/TestimonialsBlock/TestimonialsBlock.js
/* eslint-disable react/no-array-index-key */ 









const TestimonialsBlock = (param)=>{
    let { blockTitle , blockSubtitle , quoteReference =[] , internalSlug  } = param;
    const [active, activeIndex, setActiveIndex] = hooks_useTestimonial(quoteReference);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Template_Template, {
        title: blockTitle,
        subtitle: blockSubtitle,
        anchor: internalSlug,
        children: quoteReference.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                active && /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Container */.W2, {
                    spacing: {
                        sm: {
                            px: 0
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialsBlock_Testimonial, {
                        ...active.fields
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Container */.W2, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs, {
                        children: quoteReference.map((param, index)=>{
                            let { sys: { id  } , fields: { logo  }  } = param;
                            var ref, ref1;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Tab, {
                                logoImg: logo === null || logo === void 0 ? void 0 : (ref = logo.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.file) === null || ref1 === void 0 ? void 0 : ref1.url,
                                isBaseUrl: false,
                                active: activeIndex === index,
                                onClick: ()=>setActiveIndex(index),
                                invert: "white"
                            }, "".concat(id, "_").concat(index));
                        })
                    })
                })
            ]
        })
    });
};
TestimonialsBlock.propTypes = {
    internalSlug: prop_types.string.isRequired,
    blockTitle: prop_types.string,
    blockSubtitle: prop_types.string,
    quoteReference: (0,prop_types.arrayOf)((0,prop_types.shape)({
        sys: (0,prop_types.shape)({
            id: prop_types.string
        }),
        fields: (0,prop_types.shape)({
            logo: propTypes/* file */.t,
            position: prop_types.string,
            quoteAuthor: prop_types.string,
            quoteText: prop_types.string
        })
    }))
};
/* harmony default export */ var TestimonialsBlock_TestimonialsBlock = (TestimonialsBlock);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/components/TestimonialsBlock/index.js


// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/Apps/components/FeaturedContentBlock/mapper.js
var mapper = __webpack_require__(4830);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/Apps/components/FeaturedContentBlock/FeaturedContectItems.js
var FeaturedContectItems = __webpack_require__(65863);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/components/FeaturedContentBlock/FeaturedContentBlock.js






const FeaturedContentBlock = (param)=>{
    let { id , name , subname , contentReference =[] , components , ...props } = param;
    const SectionTemplate = (components === null || components === void 0 ? void 0 : components.sectionTemplate) || Template_Template;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTemplate, {
        title: name,
        subtitle: subname,
        anchor: id,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedContectItems/* default */.Z, {
            items: (0,mapper/* mapItems */.J)(contentReference),
            ...props,
            isImgFluid: true
        })
    });
};
FeaturedContentBlock.propTypes = {
    id: prop_types.string.isRequired,
    name: prop_types.string.isRequired,
    subname: prop_types.string,
    contentReference: prop_types.array,
    imgClassName: prop_types.string,
    components: (0,prop_types.shape)({
        sectionTemplate: prop_types.elementType
    })
};
/* harmony default export */ var FeaturedContentBlock_FeaturedContentBlock = (FeaturedContentBlock);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/components/FeaturedContentBlock/index.js


;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Standard/configs/featuredContentBlockConfig.js
const featuredContentBlockConfig = {
    integrations: {
        imgSpacing: {
            p: 10
        },
        imgWrapperUtility: {
            display: "flex",
            justify: "center",
            align: {
                items: "center"
            }
        },
        imgWrapperSizing: {
            h: 40
        }
    },
    "prism-academy": {
        imgSpacing: {
            p: 4
        },
        imgWrapperUtility: {
            display: "flex",
            justify: "center",
            align: {
                items: "center"
            }
        },
        imgWrapperSizing: {
            h: 40
        }
    }
};
/* harmony default export */ var configs_featuredContentBlockConfig = (featuredContentBlockConfig);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/utils/renderBlockByType.js










const renderBlockByTypeFactory = (slug, components)=>{
    const renderBlockByType = (param)=>{
        let { sys: { contentType , id  } , fields  } = param;
        // Don't show draft blocks
        if (!contentType) return null;
        const { sys: { id: type  }  } = contentType;
        const LinkSection = (components === null || components === void 0 ? void 0 : components.linksBlock) || LinksBlock_LinksBlock;
        switch(type){
            case "blockLinks":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkSection, {
                    ...fields
                }, id);
            case "blockHero":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBlock_HeroBlock, {
                    ...fields
                }, id);
            case "blockVisualCopy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(VisualCopyBlock_VisualCopyBlock, {
                    ...fields
                }, id);
            case "blockCopy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyBlock_CopyBlock, {
                    id: id,
                    ...fields
                }, id);
            case "blockTestimonials":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialsBlock_TestimonialsBlock, {
                    ...fields
                }, id);
            case "blockFeaturedContent":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedContentBlock_FeaturedContentBlock, {
                    ...fields,
                    ...configs_featuredContentBlockConfig[slug] || {},
                    components: components
                }, id);
            default:
                return null;
        }
    };
    renderBlockByType.propTypes = {
        sys: (0,prop_types.shape)({
            contentType: (0,prop_types.shape)({
                sys: (0,prop_types.shape)({
                    id: (0,prop_types.oneOf)([
                        "blockLinks",
                        "blockHero",
                        "blockVisualCopy",
                        "blockCopy",
                        "blockTestimonials",
                        "blockFeaturedContent"
                    ])
                })
            })
        }),
        fields: prop_types.object
    };
    return renderBlockByType;
};
/* harmony default export */ var renderBlockByType = (renderBlockByTypeFactory);


/***/ })

}]);